// extracted by mini-css-extract-plugin
module.exports = {"header":"unknown-user-modal_header__1j2KZ","description":"unknown-user-modal_description__2l_oc","text":"unknown-user-modal_text__3Oom2"};